import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import TalentDashboard from "@/pages/TalentDashboard";
import DriverProfile from "@/pages/DriverProfile";
import SponsorPack from "@/pages/SponsorPack";
import Sponsors from "@/pages/Sponsors";
import SponsorProfile from "@/pages/SponsorProfile";
import MatchReceipt from "@/pages/MatchReceipt";
import Inbox from "@/pages/Inbox";
import Sessions from "@/pages/Sessions";
import EventDetail from "@/pages/EventDetail";
import Intake from "@/pages/Intake";
import Incident from "@/pages/Incident";
import Incidents from "@/pages/Incidents";
import Receipt from "@/pages/Receipt";
import Receipts from "@/pages/Receipts";
import DriverOffers from "@/pages/DriverOffers";
import OfferReceipt from "@/pages/OfferReceipt";
import KatlasCapability from "@/pages/KatlasCapability";
import SatelliteScenario from "@/pages/SatelliteScenario";
import { RoleProvider } from "@/lib/roleContext";

function App() {
  return (
    <div className="App">
      <RoleProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            {/* Public read-only — no layout */}
            <Route path="/share/sponsor/:token" element={<SponsorPack publicMode />} />
            <Route path="/share/match/:token" element={<MatchReceipt publicMode />} />
            <Route element={<Layout />}>
              <Route path="/" element={<TalentDashboard />} />
              <Route path="/drivers/:id" element={<DriverProfile />} />
              <Route path="/sponsor-packs/:id" element={<SponsorPack />} />
              <Route path="/sponsors" element={<Sponsors />} />
              <Route path="/sponsors/:id" element={<SponsorProfile />} />
              <Route path="/matches/:id" element={<MatchReceipt />} />
              <Route path="/inbox" element={<Inbox />} />
              <Route path="/sessions" element={<Sessions />} />
              <Route path="/events/:id" element={<EventDetail />} />
              <Route path="/intake" element={<Intake />} />
              <Route path="/incidents" element={<Incidents />} />
              <Route path="/incidents/:id" element={<Incident />} />
              <Route path="/receipts" element={<Receipts />} />
              <Route path="/receipts/:id" element={<Receipt />} />
              <Route path="/drivers/:id/offers" element={<DriverOffers />} />
              <Route path="/offer-claims/:id" element={<OfferReceipt />} />
              <Route path="/katlas-capability" element={<KatlasCapability />} />
              <Route path="/satellites/:kind" element={<SatelliteScenario />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </RoleProvider>
    </div>
  );
}

export default App;
